import React from "react";

export default function PRFilterBar({ filters, onChange, onSearch }) {
  return (
    <div className="pr-filter-bar">

      <input
        className="pr-input"
        placeholder="Search PR no / remarks"
        value={filters.search || ""}
        onChange={(e) =>
          onChange({ ...filters, search: e.target.value })
        }
      />

      <select
        className="pr-select"
        value={filters.status || ""}
        onChange={(e) =>
          onChange({ ...filters, status: e.target.value })
        }
      >
        <option value="">All Status</option>
        <option value="DRAFT">Draft</option>
        <option value="SUBMITTED">Submitted</option>
        <option value="APPROVED">Approved</option>
      </select>

      <input
        type="date"
        className="pr-input"
        value={filters.from_date || ""}
        onChange={(e) =>
          onChange({ ...filters, from_date: e.target.value })
        }
      />

      <input
        type="date"
        className="pr-input"
        value={filters.to_date || ""}
        onChange={(e) =>
          onChange({ ...filters, to_date: e.target.value })
        }
      />

      <button
        className="btn-primary"
        onClick={onSearch}
      >
        Search
      </button>

    </div>
  );
}
